
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34020',
  depVersions: {
  "documents-public-ui": "static-1.34020",
  "client-types": "static-1.449",
  "documents-lib": "static-1.34025",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1946",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4841",
  "highcharts": "static-8.100",
  "hs-promise-utils": "static-1.5412",
  "hs-test-utils": "static-1.7823",
  "hub-http": "static-1.6038",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11249",
  "I18n": "static-7.1575",
  "jasmine-immutable": "static-1.2836",
  "jasmine-runner": "static-1.6290",
  "lodash": "static-1.3",
  "quartz": "static-1.6759",
  "react": "static-7.180",
  "react-dlb": "static-1.73",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16470",
  "reporting-data": "static-1.66607",
  "reporting-testing-lib": "static-1.8540",
  "reporting-visualizations": "static-1.58683",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4584",
  "webpack-env": "static-1.54",
  "atom": "static-1.4888",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2306",
  "classnames": "static-2.10",
  "cssUtils": "static-1.737",
  "customer-data-filters-ui": "static-1.38969",
  "customer-data-objects": "static-1.7467",
  "customer-data-property-utils": "static-1.7898",
  "data-fetching-client": "static-1.9495",
  "enviro": "static-4.405",
  "FireAlarmUi": "static-1.4349",
  "flux-actions": "static-1.310",
  "FormsCommonComponents": "static-1.85333",
  "FormUrlGenerator": "static-2.4547",
  "foundations-components": "static-1.7562",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11557",
  "icons": "static-2.623",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6978",
  "metrics-js": "static-1.9436",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.367",
  "property-description-translator": "static-1.3675",
  "property-translator": "static-1.5229",
  "quartz-config": "static-1.537",
  "quartz-core": "static-1.5978",
  "quick-fetch": "static-1.3754",
  "raven": "static-3.5725",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5192",
  "react-virtualized": "static-2.95",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7980",
  "reference-resolvers-lite": "static-1.7913",
  "report-customization-components": "static-1.12557",
  "reporting-enablement": "static-1.22136",
  "reporting-reports": "static-1.66285",
  "reporting-snowflake": "static-1.55225",
  "reporting-ui-components": "static-2.63878",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4453",
  "sales-content-partitioning": "static-1.8753",
  "SalesContentIndexUI": "static-3.8930",
  "sanitize": "static-1.4293",
  "sanitize-text": "static-1.7963",
  "self-service-api": "static-1.10057",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1569",
  "signup-constants": "static-1.18459",
  "signup-ui-lego-core": "static-1.20469",
  "signup-ui-url-generator": "static-2.7858",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.484",
  "superstore": "static-1.4588",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10813",
  "ui-addon-i18n": "static-1.10962",
  "ui-addon-react-router-dom": "static-1.9364",
  "ui-addon-upgrades": "static-9.17685",
  "ui-asset-management-lib": "static-1.10735",
  "ui-images": "static-2.1097",
  "UIComponents": "static-3.8196",
  "usage-tracker": "static-1.7154",
  "usage-tracker-container": "static-1.7144",
  "usage-tracker-core": "static-1.7004",
  "usage-tracker-public": "static-1.6965",
  "viral-links-lib": "static-1.6855",
  "hs-promise-rejection-tracking": "static-1.5387",
  "raven-hubspot": "static-1.6032",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3246",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3036",
  "quartz-webpack": "static-1.2983",
  "ai-components-ui-library": "static-1.8400",
  "amplitude-session-replay-browser": "static-1.56",
  "foundations-assets": "static-1.4654",
  "foundations-theming": "static-1.4230",
  "quartz-auth": "static-1.434",
  "ui-business-units-lib": "static-1.8847",
  "usage-tracker-session-replay": "static-1.4840",
  "foundations-theming-base": "static-1.3215",
  "HeadJS": "static-2.713",
  "framer-motion": "static-1.68",
  "hs-test-utils-bend-plugin": "static-1.2934",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4145",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7743",
  "graphql": "static-1.78",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3438",
  "persist-promise": "static-1.3526",
  "reporting-client-types": "static-1.2387",
  "foundations-components-legacy": "static-1.587",
  "hs-story-utils": "static-1.9244",
  "react-flip-move": "static-1.66",
  "hub-http-shared-msw-handlers": "static-1.9520",
  "hubspotter-http": "static-1.4495",
  "sassPrefix": "static-1.152",
  "conversations-skeleton-state": "static-1.7067",
  "crm-message-bus": "static-1.42417",
  "customer-data-filters-ui-msw-helpers": "static-1.21404",
  "customer-data-objects-ui-components": "static-1.12827",
  "customer-data-reference-ui-components": "static-1.12965",
  "customer-data-ui-utilities": "static-1.9641",
  "framework-builder-read-service-client": "static-1.3851",
  "framework-data-schema-quick-fetch": "static-1.6596",
  "framework-data-schema-resolvers": "static-1.6691",
  "inbound-db-properties-service-client": "static-1.3692",
  "multi-account-reference-resolvers": "static-1.792",
  "onboarding-tours": "static-1.16293",
  "reporting-datasets-permissions-lib": "static-1.13111",
  "ui-addon-teams": "static-1.21267",
  "apollo-stack-hubspot": "static-3.82",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67676",
  "customer-data-properties": "static-1.50851",
  "forms-ai-lib": "static-1.4036",
  "forms-utils-lib": "static-1.12205",
  "foundations-components-test-utils": "static-1.5045",
  "react-dnd-compat": "static-1.4439",
  "react-tinymce": "static-1.54671",
  "tinymce-config": "static-2.53797",
  "ui-gdpr-components": "static-1.10166",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3831",
  "floating-ui": "static-1.52",
  "react-aria": "static-1.62",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1271",
  "ui-fonts": "static-1.511",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.798",
  "mobile-manifest-mixins": "static-1.486",
  "module-federation": "static-1.19",
  "quartz-head": "static-1.424",
  "quartz-i18n": "static-1.434",
  "quartz-routing": "static-1.189",
  "quartz-test": "static-1.434",
  "quartz-tracking": "static-1.138",
  "batch-promise": "static-1.1369",
  "external-options-client-types": "static-1.4002",
  "react-colorpicker": "static-2.10029",
  "copilot-toolkit": "static-1.10582",
  "data-quality-ui-library": "static-1.12366",
  "html-to-image": "static-1.50",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6281",
  "reporting-action-components": "static-1.40705",
  "reporting-insights-lib": "static-1.1216",
  "reporting-plugins": "static-1.10010",
  "ui-addon-draggable-compat": "static-2.4072",
  "ui-addon-opt": "static-4.8202",
  "ui-shepherd-react": "static-3.9965",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24778",
  "hubspot-apollo-client": "static-1.4699",
  "sales-templates-service-types-lib": "static-1.4009",
  "merchandise-lib": "static-1.260",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5508",
  "salesImages": "static-1.521",
  "ts-schema": "static-1.3922",
  "timezone-utils": "static-2.5063",
  "bender-build-tools": "static-1.2970",
  "chatspot-core": "static-1.20409",
  "chirp-fetch": "static-1.1701",
  "bend-plugin-foundations-theming": "static-1.2713",
  "stylex": "static-1.28",
  "hubspotter-http-shared-msw-handlers": "static-1.9518",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3641",
  "crm-pipelines-api-client-types": "static-1.3983",
  "multi-currency-client-types": "static-1.3534",
  "getting-started-shared-tasks": "static-1.17936",
  "growth-data-modal": "static-1.5177",
  "growth-onboarding-confetti": "static-1.2890",
  "growth-onboarding-next-action-utils": "static-1.1338",
  "navigation-components": "static-1.17330",
  "onboarding-tours-client": "static-1.4507",
  "onboarding-tours-utils": "static-1.359",
  "ui-shepherd-tracker": "static-1.7346",
  "ui-universal-auth": "static-1.8725",
  "user-context": "static-1.4917",
  "cms-field-types": "static-1.4625",
  "content-icons-ui": "static-1.2161",
  "integrations-lib": "static-1.15483",
  "calling-global-api": "static-1.63744",
  "calling-internal-common": "static-1.31113",
  "calling-lifecycle-internal": "static-1.65126",
  "calling-lifecycle-messages": "static-1.57420",
  "commerce-products-lib": "static-1.8912",
  "crm-links": "static-1.6085",
  "file-manager-components": "static-1.22954",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.498",
  "inbounddb-objects-service-types": "static-1.4065",
  "meetings-icalendar-utils-lib": "static-1.451",
  "object-builder-ui-client": "static-1.48053",
  "pipeline-validation-client-types": "static-1.3806",
  "property-value-citations": "static-1.1465",
  "pulse": "static-1.334",
  "smart-property-lib": "static-1.5986",
  "tiered-pricing": "static-1.857",
  "ui-addon-iframeable": "static-1.8865",
  "final-form": "static-1.66",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19505",
  "tinymce-themes": "static-1.55767",
  "data-token-picker": "static-1.16076",
  "hub-http-contrib": "static-1.2861",
  "interframe": "static-3.4607",
  "tinymce-data": "static-1.39882",
  "tinymce-plugins": "static-1.56911",
  "ui-addon-sales-email": "static-1.5032",
  "magpie-lib": "static-1.5413",
  "magpie-types": "static-1.4873",
  "simple-logging-lib": "static-1.2869",
  "content-assistance-lib": "static-1.7477",
  "dashboard-lib": "static-1.80705",
  "ExportDialog": "static-6.10205",
  "hubspot-prosemirror": "static-1.17655",
  "hubspot-prosemirror-plugins": "static-1.17647",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8512",
  "campaign-roi-lib": "static-1.8333",
  "feedback-loader": "static-1.28896",
  "apollo-link-hub-http": "static-2.4470",
  "hubspot-apollo-cache": "static-1.158",
  "growth-monetization-service-types": "static-1.4329",
  "nav-client-types": "static-1.2176",
  "purchase-motions-api": "static-1.5511",
  "trials-service-types": "static-1.3730",
  "growth-onboarding-next-action-components": "static-1.1366",
  "user-context-client": "static-1.4477",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.543",
  "unified-auth-core-lib": "static-1.520",
  "getting-started-shared-tasks-store": "static-1.17054",
  "integrations-error-boundary-lib": "static-1.12898",
  "integrations-tracking-lib": "static-1.5407",
  "native-integrations-shared-strings": "static-1.7607",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10191",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31119",
  "shared-worker-versioning": "static-1.10857",
  "calling-usage-tracker": "static-1.6359",
  "voice-sms-access-library": "static-1.299",
  "customer-data-tracking": "static-1.6700",
  "commerce-permissions": "static-1.578",
  "products-iframe-lib": "static-1.7376",
  "products-ui-components-shared-msw-handlers": "static-1.9902",
  "location-customization-utils-lib": "static-1.8622",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3973",
  "video-components-external": "static-1.10623",
  "video-data-lib": "static-1.34281",
  "directed-graph": "static-1.758",
  "event-emitter": "static-1.766",
  "breeze-intelligence-kit": "static-1.5349",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9603",
  "fsm": "static-1.3550",
  "policy-lib": "static-1.6606",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9666",
  "navigation-messaging": "static-1.6657",
  "FileManagerLib": "static-1.38594",
  "NamespacedHubStyle": "static-2.8914",
  "FileManagerCore": "static-1.38453",
  "codemirror": "static-5.91",
  "layout-dnd-components": "static-1.12073",
  "layout-dnd-utils": "static-1.11048",
  "react-codemirror": "static-1.10445",
  "ui-addon-emoji-picker": "static-1.9706",
  "ui-brand-identity-lib": "static-1.14000",
  "ui-addon-video-player": "static-1.8515",
  "ui-coaching-tips": "static-1.27992",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8386",
  "payment-link-components": "static-1.22989",
  "EmailSignatureEditor": "static-1.23952",
  "eligibility-engine-service-types": "static-1.3011",
  "universal-page-editor-lib": "static-1.2818",
  "calling-orchestration-schema": "static-1.35076",
  "sales-views-client-types": "static-1.4105",
  "crm-record-cards-service-types": "static-1.3460",
  "content-media-composition-data-lib": "static-1.11526",
  "content-media-compositions": "static-2.15533",
  "media-bridge-lib": "static-1.18599",
  "trellis-story-utils": "static-1.4339",
  "storybook-react": "static-1.29",
  "audio-components": "static-1.5639",
  "FileManagerImages": "static-1.36105",
  "video-components": "static-1.12626",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4350",
  "video-embed": "static-1.35115",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67751",
  "layout-data-lib": "static-1.9373",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6401",
  "commerce-tours-lib": "static-1.5748",
  "growth-onboarding-reliability": "static-1.4905",
  "sales-checkout-service-client": "static-1.3486",
  "draft-convert": "static-2.68",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.73",
  "draft-plugins": "static-2.21341",
  "sales-email-signature-service-client": "static-1.3662",
  "hls.js": "static-1.35",
  "social-insights-client-types": "static-1.21421",
  "outpost": "static-1.4023",
  "advanced-menus-core": "static-1.14844",
  "advanced-menus-lib": "static-1.11815",
  "ui-memberships-settings-lib": "static-1.33489",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14843",
  "simple-menus-lib": "static-1.16360"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34020",
  "client-types": "/client-types/static-1.449",
  "documents-lib": "/documents-lib/static-1.34025",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1946",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4841",
  "highcharts": "/highcharts/static-8.100",
  "hs-promise-utils": "/hs-promise-utils/static-1.5412",
  "hs-test-utils": "/hs-test-utils/static-1.7823",
  "hub-http": "/hub-http/static-1.6038",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11249",
  "I18n": "/I18n/static-7.1575",
  "jasmine-immutable": "/jasmine-immutable/static-1.2836",
  "jasmine-runner": "/jasmine-runner/static-1.6290",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6759",
  "react": "/react/static-7.180",
  "react-dlb": "/react-dlb/static-1.73",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16470",
  "reporting-data": "/reporting-data/static-1.66607",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8540",
  "reporting-visualizations": "/reporting-visualizations/static-1.58683",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4584",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4888",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2306",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.737",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38969",
  "customer-data-objects": "/customer-data-objects/static-1.7467",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7898",
  "data-fetching-client": "/data-fetching-client/static-1.9495",
  "enviro": "/enviro/static-4.405",
  "FireAlarmUi": "/FireAlarmUi/static-1.4349",
  "flux-actions": "/flux-actions/static-1.310",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85333",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4547",
  "foundations-components": "/foundations-components/static-1.7562",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11557",
  "icons": "/icons/static-2.623",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6978",
  "metrics-js": "/metrics-js/static-1.9436",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "property-description-translator": "/property-description-translator/static-1.3675",
  "property-translator": "/property-translator/static-1.5229",
  "quartz-config": "/quartz-config/static-1.537",
  "quartz-core": "/quartz-core/static-1.5978",
  "quick-fetch": "/quick-fetch/static-1.3754",
  "raven": "/raven/static-3.5725",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5192",
  "react-virtualized": "/react-virtualized/static-2.95",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7980",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7913",
  "report-customization-components": "/report-customization-components/static-1.12557",
  "reporting-enablement": "/reporting-enablement/static-1.22136",
  "reporting-reports": "/reporting-reports/static-1.66285",
  "reporting-snowflake": "/reporting-snowflake/static-1.55225",
  "reporting-ui-components": "/reporting-ui-components/static-2.63878",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4453",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8753",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8930",
  "sanitize": "/sanitize/static-1.4293",
  "sanitize-text": "/sanitize-text/static-1.7963",
  "self-service-api": "/self-service-api/static-1.10057",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1569",
  "signup-constants": "/signup-constants/static-1.18459",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20469",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "superstore": "/superstore/static-1.4588",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10813",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10962",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9364",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17685",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10735",
  "ui-images": "/ui-images/static-2.1097",
  "UIComponents": "/UIComponents/static-3.8196",
  "usage-tracker": "/usage-tracker/static-1.7154",
  "usage-tracker-container": "/usage-tracker-container/static-1.7144",
  "usage-tracker-core": "/usage-tracker-core/static-1.7004",
  "usage-tracker-public": "/usage-tracker-public/static-1.6965",
  "viral-links-lib": "/viral-links-lib/static-1.6855",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3246",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3036",
  "quartz-webpack": "/quartz-webpack/static-1.2983",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8400",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4654",
  "foundations-theming": "/foundations-theming/static-1.4230",
  "quartz-auth": "/quartz-auth/static-1.434",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8847",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4840",
  "foundations-theming-base": "/foundations-theming-base/static-1.3215",
  "HeadJS": "/HeadJS/static-2.713",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2934",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4145",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7743",
  "graphql": "/graphql/static-1.78",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3438",
  "persist-promise": "/persist-promise/static-1.3526",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.587",
  "hs-story-utils": "/hs-story-utils/static-1.9244",
  "react-flip-move": "/react-flip-move/static-1.66",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9520",
  "hubspotter-http": "/hubspotter-http/static-1.4495",
  "sassPrefix": "/sassPrefix/static-1.152",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7067",
  "crm-message-bus": "/crm-message-bus/static-1.42417",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21404",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12827",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12965",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9641",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3851",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6596",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6691",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3692",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.792",
  "onboarding-tours": "/onboarding-tours/static-1.16293",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13111",
  "ui-addon-teams": "/ui-addon-teams/static-1.21267",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67676",
  "customer-data-properties": "/customer-data-properties/static-1.50851",
  "forms-ai-lib": "/forms-ai-lib/static-1.4036",
  "forms-utils-lib": "/forms-utils-lib/static-1.12205",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5045",
  "react-dnd-compat": "/react-dnd-compat/static-1.4439",
  "react-tinymce": "/react-tinymce/static-1.54671",
  "tinymce-config": "/tinymce-config/static-2.53797",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10166",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3831",
  "floating-ui": "/floating-ui/static-1.52",
  "react-aria": "/react-aria/static-1.62",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1271",
  "ui-fonts": "/ui-fonts/static-1.511",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.798",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.486",
  "module-federation": "/module-federation/static-1.19",
  "quartz-head": "/quartz-head/static-1.424",
  "quartz-i18n": "/quartz-i18n/static-1.434",
  "quartz-routing": "/quartz-routing/static-1.189",
  "quartz-test": "/quartz-test/static-1.434",
  "quartz-tracking": "/quartz-tracking/static-1.138",
  "batch-promise": "/batch-promise/static-1.1369",
  "external-options-client-types": "/external-options-client-types/static-1.4002",
  "react-colorpicker": "/react-colorpicker/static-2.10029",
  "copilot-toolkit": "/copilot-toolkit/static-1.10582",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12366",
  "html-to-image": "/html-to-image/static-1.50",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6281",
  "reporting-action-components": "/reporting-action-components/static-1.40705",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1216",
  "reporting-plugins": "/reporting-plugins/static-1.10010",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4072",
  "ui-addon-opt": "/ui-addon-opt/static-4.8202",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9965",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24778",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4699",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4009",
  "merchandise-lib": "/merchandise-lib/static-1.260",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5508",
  "salesImages": "/salesImages/static-1.521",
  "ts-schema": "/ts-schema/static-1.3922",
  "timezone-utils": "/timezone-utils/static-2.5063",
  "bender-build-tools": "/bender-build-tools/static-1.2970",
  "chatspot-core": "/chatspot-core/static-1.20409",
  "chirp-fetch": "/chirp-fetch/static-1.1701",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2713",
  "stylex": "/stylex/static-1.28",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9518",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3641",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3983",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3534",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17936",
  "growth-data-modal": "/growth-data-modal/static-1.5177",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2890",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1338",
  "navigation-components": "/navigation-components/static-1.17330",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4507",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.359",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7346",
  "ui-universal-auth": "/ui-universal-auth/static-1.8725",
  "user-context": "/user-context/static-1.4917",
  "cms-field-types": "/cms-field-types/static-1.4625",
  "content-icons-ui": "/content-icons-ui/static-1.2161",
  "integrations-lib": "/integrations-lib/static-1.15483",
  "calling-global-api": "/calling-global-api/static-1.63744",
  "calling-internal-common": "/calling-internal-common/static-1.31113",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65126",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57420",
  "commerce-products-lib": "/commerce-products-lib/static-1.8912",
  "crm-links": "/crm-links/static-1.6085",
  "file-manager-components": "/file-manager-components/static-1.22954",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.498",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4065",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.451",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48053",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3806",
  "property-value-citations": "/property-value-citations/static-1.1465",
  "pulse": "/pulse/static-1.334",
  "smart-property-lib": "/smart-property-lib/static-1.5986",
  "tiered-pricing": "/tiered-pricing/static-1.857",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8865",
  "final-form": "/final-form/static-1.66",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19505",
  "tinymce-themes": "/tinymce-themes/static-1.55767",
  "data-token-picker": "/data-token-picker/static-1.16076",
  "hub-http-contrib": "/hub-http-contrib/static-1.2861",
  "interframe": "/interframe/static-3.4607",
  "tinymce-data": "/tinymce-data/static-1.39882",
  "tinymce-plugins": "/tinymce-plugins/static-1.56911",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5032",
  "magpie-lib": "/magpie-lib/static-1.5413",
  "magpie-types": "/magpie-types/static-1.4873",
  "simple-logging-lib": "/simple-logging-lib/static-1.2869",
  "content-assistance-lib": "/content-assistance-lib/static-1.7477",
  "dashboard-lib": "/dashboard-lib/static-1.80705",
  "ExportDialog": "/ExportDialog/static-6.10205",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17655",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17647",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8512",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8333",
  "feedback-loader": "/feedback-loader/static-1.28896",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4470",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.158",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4329",
  "nav-client-types": "/nav-client-types/static-1.2176",
  "purchase-motions-api": "/purchase-motions-api/static-1.5511",
  "trials-service-types": "/trials-service-types/static-1.3730",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1366",
  "user-context-client": "/user-context-client/static-1.4477",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.543",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.520",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17054",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12898",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5407",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7607",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10191",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31119",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10857",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6359",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.299",
  "customer-data-tracking": "/customer-data-tracking/static-1.6700",
  "commerce-permissions": "/commerce-permissions/static-1.578",
  "products-iframe-lib": "/products-iframe-lib/static-1.7376",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9902",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8622",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3973",
  "video-components-external": "/video-components-external/static-1.10623",
  "video-data-lib": "/video-data-lib/static-1.34281",
  "directed-graph": "/directed-graph/static-1.758",
  "event-emitter": "/event-emitter/static-1.766",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5349",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9603",
  "fsm": "/fsm/static-1.3550",
  "policy-lib": "/policy-lib/static-1.6606",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9666",
  "navigation-messaging": "/navigation-messaging/static-1.6657",
  "FileManagerLib": "/FileManagerLib/static-1.38594",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8914",
  "FileManagerCore": "/FileManagerCore/static-1.38453",
  "codemirror": "/codemirror/static-5.91",
  "layout-dnd-components": "/layout-dnd-components/static-1.12073",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11048",
  "react-codemirror": "/react-codemirror/static-1.10445",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9706",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14000",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8515",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27992",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8386",
  "payment-link-components": "/payment-link-components/static-1.22989",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23952",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3011",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2818",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35076",
  "sales-views-client-types": "/sales-views-client-types/static-1.4105",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3460",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11526",
  "content-media-compositions": "/content-media-compositions/static-2.15533",
  "media-bridge-lib": "/media-bridge-lib/static-1.18599",
  "trellis-story-utils": "/trellis-story-utils/static-1.4339",
  "storybook-react": "/storybook-react/static-1.29",
  "audio-components": "/audio-components/static-1.5639",
  "FileManagerImages": "/FileManagerImages/static-1.36105",
  "video-components": "/video-components/static-1.12626",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4350",
  "video-embed": "/video-embed/static-1.35115",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67751",
  "layout-data-lib": "/layout-data-lib/static-1.9373",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6401",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5748",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4905",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3486",
  "draft-convert": "/draft-convert/static-2.68",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.73",
  "draft-plugins": "/draft-plugins/static-2.21341",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3662",
  "hls.js": "/hls.js/static-1.35",
  "social-insights-client-types": "/social-insights-client-types/static-1.21421",
  "outpost": "/outpost/static-1.4023",
  "advanced-menus-core": "/advanced-menus-core/static-1.14844",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11815",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33489",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14843",
  "simple-menus-lib": "/simple-menus-lib/static-1.16360"
}
};
